export const autocompleteDropdownItemStyle = {
	root: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 1,
		width: '100%',
		px: '12px',
		height: 36,
		cursor: 'pointer'
	},
	label: {
		display: 'block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		color: 'text.primary',
		fontSize: '1rem',
		flexGrow: 1,
		minWidth: 0
	},
	count: {
		color: 'text.secondary',
		fontSize: '1rem',
		whiteSpace: 'nowrap',
		flexShrink: 0
	}
};
